import { useState } from 'react'

import { CardTab, DataCardWithTabs } from '@/components/card'
import { MappedTournamentsTable, UnmappedTournamentsTable } from '@/components/ImportEvents'
import { TitleSetter } from '@/components/Title'

const TABS = [
  {
    value: 'unmapped-tournaments',
    label: 'Unmapped Tournaments'
  },
  {
    value: 'mapped-tournaments',
    label: 'Mapped Tournaments'
  }
]

export const TournamentsView = () => {
  const [currentTab, setCurrentTab] = useState(TABS[0].value)

  return (
    <>
      <TitleSetter title="Import Events" />

      <DataCardWithTabs
        title="Import Events"
        tabs={TABS}
        currentTab={currentTab}
        onTabChange={(tab) => setCurrentTab(tab)}
      >
        <CardTab value={TABS[0].value}>
          <UnmappedTournamentsTable />
        </CardTab>
        <CardTab value={TABS[1].value}>
          <MappedTournamentsTable />
        </CardTab>
      </DataCardWithTabs>
    </>
  )
}
